import { render, staticRenderFns } from "./BusinessPlan.vue?vue&type=template&id=48a4b5d4&"
import script from "./BusinessPlan.vue?vue&type=script&lang=js&"
export * from "./BusinessPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports